import { gql } from "@apollo/client";

export default gql`
  mutation askAiForkPlatformSkill($slug: String!, $organizationId: Int) {
    forkPlatformSkill(slug: $slug, organizationId: $organizationId) {
      skill {
        id
        name
        slug
        description
        body
      }
    }
  }
`;
